import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import PDFCrossRefSection from "PDFLib/core/document/PDFCrossRefSection";

export class XRefItem extends JSONItemBase{
    GetType() {
        return 'XR';
    }

    public Sections:any;

    constructor(private xref:PDFCrossRefSection) {
        super();
        this.Sections=xref.subsections;
    }
}